module.exports = __webpack_public_path__ + "media/images/hanger-69c401d7b725df30450e6093ca9d1c2f.svg";